<template>
    <h1>AdInvoicesApprove</h1>
</template>

<script>
  export default {
    data() {
      return {}
    },
  }
</script>

<style scoped>

</style>
